/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import cn from "classnames";
import Label from "components/ui/Label";
import Stack from "components/ui/Stack";

import verifyOnlyEnglish from "utils/verifyOnlyEnglish";
import Input from "../Input";

const RULES = {
  "At least 8 characters": (word) => word?.length >= 8,
  "At least one number": (word) => /[0-9]/.test(word),
  "At least one uppercase letter": (word) => /[A-Z]/.test(word),
  "At least one lowercase letter": (word) => /[a-z]/.test(word),
};

const PasswordInput = ({ password, onChange, disabled }) => {
  return (
    <Stack test-id="XXUhccd6">
      <Label size="large" htmlFor="password" isRequired test-id="HuR_C8l2">
        Password
      </Label>

      <Input
        id="password"
        disabled={disabled}
        name="password"
        placeholder="password alt"
        value={password}
        onChange={(e) => onChange(verifyOnlyEnglish(e.target.value))}
        test-id="wSg9undq"
      />

      <ul
        className="grid grid-cols-2 list-disc list-inside gap-y-1 gap-x-2 mt-s10"
        test-id="hyasQBN1"
      >
        {Object.keys(RULES).map((rule, i) => (
          <li
            key={i}
            className={cn("text-xs text-white", {
              "!text-tertiary-accent": RULES[rule](password),
            })}
            test-id="e7ZC2c6w"
          >
            <span className="relative -left-1" test-id="ZYREPAw-">
              {rule}
            </span>
          </li>
        ))}
      </ul>
    </Stack>
  );
};

export default PasswordInput;
